import * as React from 'react';
import { FilterTagProps } from '../components/filters/filter-tags';

export interface FilterTagExternalProps {
    filterKey: string,
    value: string
}

export type CombinedFilterTagViewProps = FilterTagProps & FilterTagExternalProps;

const FilterTagView: React.StatelessComponent<CombinedFilterTagViewProps> = props => {

    const splitValues = props.value.split(",");
    return (
        <>
            {
                splitValues.map(v => <button type="button" className="un-btn filter-tag" onClick={() => { props.removeFilter(props.filterKey, v,props.eventFilters) }}>{v.split("|")[1]}</button>)
            }
        </>
    );
}

export default FilterTagView;